import React from 'react'
import CookieAlert from '@/Components/FdComponents/CookieAlert'

type CookieContextProviderProps = {
  children: React.ReactNode
}

const CookieContext = React.createContext({})

const CookieContextProvider: React.FC<CookieContextProviderProps> = (props) => {
  const [modalContext] = React.useState({})

  return (
    <CookieContext.Provider value={modalContext}>
      {props.children}
      <CookieAlert />
    </CookieContext.Provider>
  )
}

const useCookieContext = () => React.useContext(CookieContext)

export { useCookieContext }

export default CookieContextProvider
